module.exports = __webpack_public_path__ + "static/media/tgz.d3e647a4.png";